import { YAxisCategoryNames } from 'components/YAxisUnitSelector/constants';

export const categoryToSupport: YAxisCategoryNames[] = [
	YAxisCategoryNames.None,
	YAxisCategoryNames.Data,
	YAxisCategoryNames.DataRate,
	YAxisCategoryNames.Time,
	YAxisCategoryNames.Count,
	YAxisCategoryNames.Operations,
	YAxisCategoryNames.Percentage,
	YAxisCategoryNames.Miscellaneous,
	YAxisCategoryNames.Boolean,
];
